type Props = {
  width?: string;
  height?: string;
  fillColor?: string;
  strokeColor?: string;
};

/**
 * YouTube-style CC (subtitles / closed captions) glyph — a rounded rectangle
 * with the letters "CC" inside. Stroked outline so it reads on bright video
 * frames in the safe-zone overlay's player chrome.
 *
 * Used by the YouTube long-form-video safe-zone overlay's controls bar.
 * Distinct from generic caption / subtitle icons elsewhere in the codebase
 * because YouTube paints its CC affordance with an explicit "CC" text label
 * inside a rounded box (rather than a speech-bubble or text-line glyph).
 */
const YouTubeCCIcon = (props: Props) => {
  const {
    width = '20',
    height = '14',
    fillColor = 'none',
    strokeColor = '#ffffff',
  } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 14"
      fill="none"
      aria-hidden
    >
      <rect
        x="0.75"
        y="0.75"
        width="18.5"
        height="12.5"
        rx="2.25"
        fill={fillColor}
        stroke={strokeColor}
        strokeWidth="1.5"
      />
      <path
        d="M7.5 5.4c-.45-.55-1.1-.85-1.85-.85-1.35 0-2.4.95-2.4 2.45s1.05 2.45 2.4 2.45c.75 0 1.4-.3 1.85-.85"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M16.5 5.4c-.45-.55-1.1-.85-1.85-.85-1.35 0-2.4.95-2.4 2.45s1.05 2.45 2.4 2.45c.75 0 1.4-.3 1.85-.85"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
};

export default YouTubeCCIcon;
